/**
 * SI_Changement_Adresse_AccesD
 *
 * Contact: DPSL_UNICODES@desjardins.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InfosCarte {
  /**
   * Nom de produit
   */
  descriptionCourte: string;
  /**
   * Numero de carte tokenise
   */
  numeroCarte: string;
  /**
   * Le type de carte
   */
  typeCarte: InfosCarteTypeCarteEnum;
}
export enum InfosCarteTypeCarteEnum {
  ORDINAIRE = 'ordinaire',
  PREPAYEE = 'prepayee',
  AFFAIRE = 'affaire',
  PRIVATIVE = 'privative',
  ASSOCIATIVE = 'associative',
  COAST = 'coast',
}
